import React, { useRef } from 'react';
import { createStyleSheet, useStyleSheet, Focusable, Text, Icon, useThemeContext, View, Counter } from '@gopeerproject/ui-kit';
import { Link } from '../Link';
export const NavItem = ({ icon, text, to, external, counter, style, size, withArrow, circular, minimized, isActive }) => {
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    const container = useRef(null);
    return (React.createElement(Link, { ref: container, to: to, external: external, style: style },
        React.createElement(Focusable, { style: [
                styles.container,
                styles[size],
                circular ? styles.circular : {},
                !minimized ? styles.container__md : {},
                isActive ? styles.activeContainer : {}
            ], hoverStyle: styles.hover, onPress: (e) => {
                var _a;
                e.preventDefault();
                (_a = container.current) === null || _a === void 0 ? void 0 : _a.click();
            } },
            React.createElement(View, { style: styles.icon },
                React.createElement(Icon, { name: icon, size: 23, color: color.invert2.p100, filled: isActive }),
                counter ? React.createElement(Counter, { value: counter, style: styles.counter }) : null),
            !minimized && (React.createElement(Text, { type: 'body', size: 'lg', weight: isActive ? 'semibold' : 'regular', style: styles.text }, text)),
            withArrow && !minimized && (React.createElement(View, { style: styles.arrow },
                React.createElement(Icon, { name: 'chevron-right', size: 23, color: color.invert2.p100, filled: isActive }))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: size.E
    },
    circular: {
        borderRadius: 9999
    },
    container__md: {
        paddingRight: size.E
    },
    md: {
        paddingVertical: size.E,
        paddingLeft: size.E,
        paddingRight: size.G
    },
    lg: {
        paddingVertical: size.G,
        paddingLeft: size.E,
        paddingRight: size.G
    },
    hover: {
        backgroundColor: color.invert2.p4
    },
    text: {
        color: color.invert2.p100,
        marginLeft: size.C,
        flex: 1
    },
    activeContainer: {
        backgroundColor: color.invert2.p4
    },
    icon: {},
    counter: {
        position: 'absolute',
        bottom: 11,
        left: 11
    },
    arrow: {
        marginLeft: size.C
    }
}));
//# sourceMappingURL=index.js.map